<div class="email-preview-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>{{ 'DIALOG.EMAIL_PREVIEW' | translate }}</h2>
    <button mat-icon-button (click)="onClose()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="email-content">
    <div class="email-header">
      <div class="email-field">
        <label><strong>{{ 'DIALOG.EMAIL_SUBJECT' | translate }}</strong></label>
        <input 
          type="text" 
          [formControl]="subjectForm.controls['subject']"
          class="email-subject-input"
          [placeholder]="'APPOINTMENT_EDIT.SUBJECT' | translate"
          style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px; font-size: 14px;">
      </div>
    </div>

    <div class="email-body">
      <label><strong>{{ 'DIALOG.EMAIL_CONTENT' | translate }}</strong></label>
      <div class="email-content-html" [innerHTML]="data.content"></div>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="onCancel()">{{ 'COMMON.CANCEL' | translate }}</button>
    <button mat-button (click)="onClose()" color="primary">OK</button>
  </div>
</div>


